"use client";

import { useTranslations } from "next-intl";

import { Globe } from "../../core/Globe/Globe";

export default function GlobeSection() {
  const t = useTranslations("ClientKeys.v3");

  return (
    <div className='container py-80 pb-0 md:py-200 lg:pb-0'>
      <div className='mx-auto mb-32 max-w-[500px] text-center'>
        <h2 className='f-heading-03 mb-32'>{t("globe.title")}</h2>
        <p className='f-description-02'>{t("globe.description")}</p>
      </div>
      <Globe />
    </div>
  );
}
